$(document).ready(function(){
  
  $(".custom_ul_header>li>header-menu .custom_hover").mouseenter(function(){
    let details = $(this);

    if(typeof details.attr('open') == 'undefined' ){
      $(this).parents('.custom_ul_header').find('details').removeAttr('open');
      details.find('details').first().attr('open',true);
      details.attr('open',true);
    }
  }).mouseleave(function() {
    $(this).parents('.custom_ul_header').find('details').removeAttr('open');
  });
  
   $(".level_2_submenu details").hover(function(){
    $(this).parents('.level_2_submenu').find('details').removeAttr('open');
    $(this).attr('open',true);
  });

});
